/**
 *
 * IMPORTANT:
 * This file is used both in vue2 and vue3 application
 * dont add vue syntax and store concept in this file
 * For clarifications contact Divya
 *
 */
import Axios from 'axios';
import { DecodeHtml } from '../DecodeHtml';
import { SMARTPATH_CTAs, SMARTPATH_MESSAGES } from '../../constants/constants';
import { MCGEE_TOYOTA_OF_CLAREMONT, MCGEE_TOYOTA_OF_EPPING } from '../../constants/VehicleAccounts';

export class SmartPathService {
  static getDealerAdjustmentLabel() {
    if ([MCGEE_TOYOTA_OF_EPPING, MCGEE_TOYOTA_OF_CLAREMONT].includes(window.accountId)) {
      return '+/- McGee Adjustment ';
    }
    return '+/- Dealer Adjustment ';
  }

  static prepareInventorySaveHeart() {
    let data = {};
    let vehicles = [];
    if (window.smartPathIntegrationInventory) {
      vehicles = JSON.parse(DecodeHtml.decodeHtml(window.smartPathIntegrationInventory));
      if (vehicles.length) {
        vehicles.forEach((element) => {
          data[`dg-inline-save-inv-${element.VIN}`] = {
            type: 'inv',
            brand: element.Make,
            modelCd: element.ModelNumber,
            dealerCd: window.oemCode,
            // dealerCd: 41086,
            advertisedPrice: element.SellingPrice,
            imageHref: element.PhotoUrls,
            marketingSeries: element.Trim,
            marketingName: element.Trim,
            year: Number(element.Year),
            vin: element.VIN,
            price: element.YourPrice,
            imagePrice: element.YourPrice,
            ePrice: 0,
            vdpHref: element.VdpUrl ? element.VdpUrl : '',
            vlpHref: window.location.href,
            salesClass: element.Type.toLowerCase(),
            vehicleType: element.Type.toLowerCase(),
            options: [],
            baseMsrp: element.MSRP,
          };
        });
      }
    }

    return data;
  }

  static prepareVehicleDetailsSaveHeart() {
    let data = {};
    let vehicle = null;
    if (window.smartPathVehilceObj) {
      vehicle = JSON.parse(DecodeHtml.decodeHtml(window.smartPathVehilceObj));
      if (vehicle) {
        data[`dg-inline-save-inv-${vehicle.VIN}`] = {
          type: 'inv',
          brand: vehicle.Make,
          modelCd: vehicle.ModelNumber,
          dealerCd: window.oemCode,
          // dealerCd: 41086,
          advertisedPrice: vehicle.SellingPrice,
          imageHref: vehicle.PhotoUrls,
          marketingSeries: vehicle.Trim,
          marketingName: vehicle.Trim,
          year: vehicle.Year,
          vin: vehicle.VIN,
          price: vehicle.SellingPrice,
          imagePrice: vehicle.SellingPrice,
          ePrice: 0,
          vdpHref: vehicle.VdpUrl ? vehicle.VdpUrl : window.location.href,
          vlpHref: window.location.href,
          salesClass: vehicle.Type.toLowerCase(),
          vehicleType: vehicle.Type.toLowerCase(),
          options: [],
          baseMsrp: vehicle.MSRP,
        };
      }
    }

    return data;
  }

  static smartPathRedirection(from, vin, vehicleType, option, route, target = '_self') {
    target = target?.toLowerCase().includes('new') ? '_blank' : '_self';
    let vType =
      vehicleType && vehicleType.toLowerCase() === 'new' ? 'new' : vehicleType.toLowerCase();

    let url = `${window.smartPathSubsiteUrl}/inventory/details`;

    let queryParam = `?source=t3&dealerCd=${window.oemCode}&vin=${vin}&type=${vType}`;
    switch (option) {
      case 'unlock-savings':
        queryParam = queryParam + '&unlockSavings=true';
        break;
      case 'sp-value-your-trade':
        queryParam = `?source=t3&dealerCd=${window.oemCode}&vin=${vin}&zipcode=${window.zip}&type=${vType}&trade=true`;
        break;
      case 'sp-confirm-availability':
        queryParam = queryParam + '&contact=true';
        break;
      case 'sp-estimate-payment':
        queryParam = queryParam + '';
        break;
      case 'estimated-payments':
      case 'toyota-smartpath':
        queryParam = route ? '' : queryParam + '';
        if (route) {
          url = route;
        }
        break;
      default:
        return false;
    }
    let redirectUrl = (url + queryParam).replace('#vin', vin);
    if (window.location !== window.parent.location) {
      window.parent.open(redirectUrl, target);
    } else {
      window.open(redirectUrl, target);
    }
    return true;
  }

  static smartPathUnlockStatus() {
    const env = window.environment ? window.environment.toLowerCase() : '';

    let url = `https://mobile-api.rti.toyota.com/leads/garage/eprice?dgid=${window.DGDataHub.getDgid()}&dealerCd=${
      window.oemCode
    }`;

    if (env === 'stage') {
      url = `https://mobile-api.rti.qa.toyota.com/leads/garage/eprice?dgid=${window.DGDataHub.getDgid()}&dealerCd=${
        window.oemCode
      }`;
    }

    return Axios.get(url);
  }

  static smartPathPriceDisplayLogic(priceObject, isUnlocked = false) {
    const pricesList = [];
    if (priceObject) {
      if (!isUnlocked) {
        // DIOs Absent, Advertised Price ≠ MSRP, Cash Rebate Absent
        if (
          !priceObject.isDealerInstalledAccessoriesObj.DIOPrice &&
          priceObject.AdvertisedPriceObj.AdvertisedPrice !== priceObject.MSRPObj.MSRP &&
          !priceObject.isCashRebateObj.CashRebate
        ) {
          console.log('LOCKED : DIOs Absent, Advertised Price ≠ MSRP, Cash Rebate Absent');
          const MSRP = {
            label: priceObject.MSRPObj.InMSRPLabel,
            type: 'msrp',
            value: priceObject.MSRPObj.MSRP,
            disclaimer: priceObject.MSRPObj.Disclaimer,
            labelClass: '',
            valueClass: '',
          };

          const AdvertisedPriceCHeck = !priceObject.AdvertisedPriceObj.AdvertisedPrice
            ? priceObject.SmartPriceObj.SmartPrice
            : priceObject.AdvertisedPriceObj.AdvertisedPrice;

          const dealerAdjustMentPrice = {
            label: this.getDealerAdjustmentLabel(),
            type: 'dealeradvertisedprice',
            value: AdvertisedPriceCHeck - priceObject.MSRPObj.MSRP,
            disclaimer: '',
            labelClass: 'ml-4 ft-12',
            parentClass: 'sp-dealer-adjustment',
            priceValue: 'sp-dealer-adjustment-price',
          };

          const AdvertisedPrice = {
            label: 'Advertised Price ',
            type: 'advertisedprice',
            labelClass: 'font-weight-bold  _theme_font_bold',
            valueClass: 'font-weight-bold  _theme_font_bold',
            value: AdvertisedPriceCHeck,
            disclaimer: priceObject.AdvertisedPriceObj.Disclaimer,
          };

          pricesList.push(MSRP);
          dealerAdjustMentPrice?.value !== 0 && pricesList.push(dealerAdjustMentPrice);
          pricesList.push(AdvertisedPrice);
        }
        // DIOs Absent, Advertised Price = MSRP, Cash Rebate Absent
        else if (
          !priceObject.isDealerInstalledAccessoriesObj.DIOPrice &&
          priceObject.AdvertisedPriceObj.AdvertisedPrice === priceObject.MSRPObj.MSRP &&
          !priceObject.isCashRebateObj.CashRebate
        ) {
          console.log('LOCKED : DIOs Absent, Advertised Price = MSRP, Cash Rebate Absent');
          const MSRP = {
            label: priceObject.MSRPObj.InMSRPLabel,
            type: 'msrp',
            value: priceObject.MSRPObj.MSRP,
            disclaimer: priceObject.MSRPObj.Disclaimer,
            labelClass: 'font-weight-bold  _theme_font_bold',
            valueClass: 'font-weight-bold  _theme_font_bold',
          };
          pricesList.push(MSRP);
        }
        // DIOs Absent, Advertised Price ≠ MSRP, Cash Rebate Present
        else if (
          !priceObject.isDealerInstalledAccessoriesObj.DIOPrice &&
          priceObject.AdvertisedPriceObj.AdvertisedPrice !== priceObject.MSRPObj.MSRP &&
          priceObject.isCashRebateObj.CashRebate
        ) {
          console.log('LOCKED : DIOs Absent, Advertised Price ≠ MSRP, Cash Rebate Present');
          const MSRP = {
            label: priceObject.MSRPObj.InMSRPLabel,
            type: 'msrp',
            value: priceObject.MSRPObj.MSRP,
            disclaimer: priceObject.MSRPObj.Disclaimer,
            labelClass: '',
            valueClass: '',
          };

          const AdvertisedPriceCHeck = !priceObject.AdvertisedPriceObj.AdvertisedPrice
            ? priceObject.SmartPriceObj.SmartPrice
            : priceObject.AdvertisedPriceObj.AdvertisedPrice;

          const dealerAdjustMentPrice = {
            label: this.getDealerAdjustmentLabel(),
            type: 'dealeradvertisedprice',
            labelClass: 'ml-4 ft-12',
            value: AdvertisedPriceCHeck - priceObject.MSRPObj.MSRP,
            disclaimer: '',
            parentClass: 'sp-dealer-adjustment',
            priceValue: 'sp-dealer-adjustment-price',
          };

          const AdvertisedPrice = {
            label: 'Advertised Price ',
            type: 'advertisedprice',
            labelClass: 'font-italic',
            value: AdvertisedPriceCHeck,
            disclaimer: priceObject.AdvertisedPriceObj.Disclaimer,
          };

          const cashOffer = {
            label: '- Available Cash Offers  ',
            type: 'advertisedprice',
            value: priceObject.isCashRebateObj.CashRebate,
            disclaimer: priceObject.isCashRebateObj.Disclaimer,
            labelClass: 'ml-4 ft-12',
            symbol: '-',
          };

          const discountedAdvertisedPrice = {
            label: 'Discounted Advertised Price',
            type: 'advertisedprice',
            value: AdvertisedPriceCHeck - priceObject.isCashRebateObj.CashRebate,
            disclaimer: '',
            labelClass: 'font-weight-bold  _theme_font_bold',
            valueClass: 'font-weight-bold  _theme_font_bold',
          };

          pricesList.push(MSRP);
          dealerAdjustMentPrice?.value !== 0 && pricesList.push(dealerAdjustMentPrice);
          pricesList.push(AdvertisedPrice);
          pricesList.push(cashOffer);
          pricesList.push(discountedAdvertisedPrice);
        }
        // DIOs Absent, Advertised Price = MSRP, Cash Rebate Present
        else if (
          !priceObject.isDealerInstalledAccessoriesObj.DIOPrice &&
          priceObject.AdvertisedPriceObj.AdvertisedPrice === priceObject.MSRPObj.MSRP &&
          priceObject.isCashRebateObj.CashRebate
        ) {
          console.log('LOCKED: DIOs Absent, Advertised Price = MSRP, Cash Rebate Present');

          const MSRP = {
            label: priceObject.MSRPObj.InMSRPLabel,
            type: 'msrp',
            value: priceObject.MSRPObj.MSRP,
            disclaimer: priceObject.MSRPObj.Disclaimer,
            labelClass: '',
            valueClass: '',
          };

          const cashOffer = {
            label: '- Available Cash Offers  ',
            type: 'avalablecashprice',
            value: priceObject.isCashRebateObj.CashRebate,
            disclaimer: '',
            labelClass: 'ml-4 ft-12',
            symbol: '-',
          };

          const AdvertisedPriceCHeck = !priceObject.AdvertisedPriceObj.AdvertisedPrice
            ? priceObject.SmartPriceObj.SmartPrice
            : priceObject.AdvertisedPriceObj.AdvertisedPrice;

          const discountedAdvertisedPrice = {
            label: 'Discounted Advertised Price',
            type: 'avalablecashprice',
            value: AdvertisedPriceCHeck - priceObject.isCashRebateObj.CashRebate,
            disclaimer: priceObject.isCashRebateObj.Disclaimer,
            labelClass: 'font-weight-bold  _theme_font_bold',
            valueClass: 'font-weight-bold  _theme_font_bold',
          };

          pricesList.push(MSRP);
          pricesList.push(cashOffer);
          pricesList.push(discountedAdvertisedPrice);
        }
        // DIOs Present, Advertised Price ≠ MSRP, Cash Rebate Absent
        else if (
          priceObject.isDealerInstalledAccessoriesObj.DIOPrice &&
          priceObject.AdvertisedPriceObj.AdvertisedPrice !== priceObject.MSRPObj.MSRP &&
          !priceObject.isCashRebateObj.CashRebate
        ) {
          console.log('LOCKED: DIOs Present, Advertised Price ≠ MSRP, Cash Rebate Absent');

          const MSRP = {
            label: priceObject.MSRPObj.InMSRPLabel,
            type: 'msrp',
            value: priceObject.MSRPObj.MSRP,
            disclaimer: priceObject.MSRPObj.Disclaimer,
            labelClass: '',
            valueClass: '',
          };

          const dealerInstalledAccesories = {
            label: '+ Dealer Installed Accessories ',
            type: 'dealerinstalledaccess',
            value: priceObject.isDealerInstalledAccessoriesObj.DIOPrice,
            disclaimer: SMARTPATH_MESSAGES.DIA_Disclamer,
            labelClass: 'ml-4 ft-12',
          };

          const AdvertisedPriceCHeck = !priceObject.AdvertisedPriceObj.AdvertisedPrice
            ? priceObject.SmartPriceObj.SmartPrice
            : priceObject.AdvertisedPriceObj.AdvertisedPrice;

          const dealerAdjustMentPrice = {
            label: this.getDealerAdjustmentLabel(),
            type: 'dealeradvertisedprice',
            labelClass: 'ml-4 ft-12',
            value:
              AdvertisedPriceCHeck -
              (priceObject.MSRPObj.MSRP + priceObject.isDealerInstalledAccessoriesObj.DIOPrice),
            disclaimer: '',
            parentClass: 'sp-dealer-adjustment',
            priceValue: 'sp-dealer-adjustment-price',
          };

          const advertisedprice = {
            label: 'Advertised Price ',
            type: 'advertisedprice',
            labelClass: 'font-weight-bold  _theme_font_bold',
            valueClass: 'font-weight-bold  _theme_font_bold',
            value: AdvertisedPriceCHeck,
            disclaimer: priceObject.AdvertisedPriceObj.Disclaimer,
          };

          pricesList.push(MSRP);
          pricesList.push(dealerInstalledAccesories);
          dealerAdjustMentPrice?.value !== 0 && pricesList.push(dealerAdjustMentPrice);
          pricesList.push(advertisedprice);
        }
        // DIOs Present, Advertised Price = MSRP, Cash Rebate Absent
        else if (
          priceObject.isDealerInstalledAccessoriesObj.DIOPrice &&
          priceObject.AdvertisedPriceObj.AdvertisedPrice === priceObject.MSRPObj.MSRP &&
          !priceObject.isCashRebateObj.CashRebate
        ) {
          console.log('LOCKED : DIOs Present, Advertised Price = MSRP, Cash Rebate Absent');

          const MSRP = {
            label: priceObject.MSRPObj.InMSRPLabel,
            type: 'msrp',
            value: priceObject.MSRPObj.MSRP,
            disclaimer: priceObject.MSRPObj.Disclaimer,
            labelClass: '',
            valueClass: '',
          };

          const dealerInstalledAccesories = {
            label: '+ Dealer Installed Accessories ',
            type: 'dealerinstalledaccess',
            value: priceObject.isDealerInstalledAccessoriesObj.DIOPrice,
            disclaimer: SMARTPATH_MESSAGES.DIA_Disclamer,
            labelClass: 'ml-4 ft-12',
          };

          const AdvertisedPriceCHeck = !priceObject.AdvertisedPriceObj.AdvertisedPrice
            ? priceObject.SmartPriceObj.SmartPrice
            : priceObject.AdvertisedPriceObj.AdvertisedPrice;

          const dealerAdjustMentPrice = {
            label: this.getDealerAdjustmentLabel(),
            type: 'dealerAdjustMentPrice',
            labelClass: 'ml-4 ft-12',
            value:
              AdvertisedPriceCHeck -
              (priceObject.MSRPObj.MSRP + priceObject.isDealerInstalledAccessoriesObj.DIOPrice),
            disclaimer: '',
            parentClass: 'sp-dealer-adjustment',
            priceValue: 'sp-dealer-adjustment-price',
          };

          const advertisedPrice = {
            label: 'Advertised Price ',
            type: 'advertisedprice',
            labelClass: 'font-weight-bold  _theme_font_bold',
            valueClass: 'font-weight-bold  _theme_font_bold',
            value: priceObject.AdvertisedPriceObj.AdvertisedPrice,
            disclaimer: priceObject.AdvertisedPriceObj.Disclaimer,
          };

          pricesList.push(MSRP);
          pricesList.push(dealerInstalledAccesories);
          dealerAdjustMentPrice?.value !== 0 && pricesList.push(dealerAdjustMentPrice);
          pricesList.push(advertisedPrice);
        }
        // DIOs Present, Advertised Price ≠ MSRP, Cash Rebate Present
        else if (
          priceObject.isDealerInstalledAccessoriesObj.DIOPrice &&
          priceObject.AdvertisedPriceObj.AdvertisedPrice !== priceObject.MSRPObj.MSRP &&
          priceObject.isCashRebateObj.CashRebate
        ) {
          console.log('LOCKED : DIOs Present, Advertised Price ≠ MSRP, Cash Rebate Present');

          const MSRP = {
            label: priceObject.MSRPObj.InMSRPLabel,
            type: 'msrp',
            value: priceObject.MSRPObj.MSRP,
            disclaimer: priceObject.MSRPObj.Disclaimer,
            labelClass: '',
            valueClass: '',
          };

          const dealerInstalledAccesories = {
            label: '+ Dealer Installed Accessories ',
            type: 'dealerinstalledaccess',
            value: priceObject.isDealerInstalledAccessoriesObj.DIOPrice,
            disclaimer: SMARTPATH_MESSAGES.DIA_Disclamer,
            labelClass: 'ml-4 ft-12',
          };

          const AdvertisedPriceCHeck = !priceObject.AdvertisedPriceObj.AdvertisedPrice
            ? priceObject.SmartPriceObj.SmartPrice
            : priceObject.AdvertisedPriceObj.AdvertisedPrice;

          const dealerAdjustMentPrice = {
            label: this.getDealerAdjustmentLabel(),
            type: 'dealeradvertisedprice',
            labelClass: 'ml-4 ft-12',
            value:
              AdvertisedPriceCHeck -
              (priceObject.MSRPObj.MSRP + priceObject.isDealerInstalledAccessoriesObj.DIOPrice),
            disclaimer: '',
            parentClass: 'sp-dealer-adjustment',
            priceValue: 'sp-dealer-adjustment-price',
          };

          const AdvertisedPrice = {
            label: 'Advertised Price ',
            type: 'advertisedprice',
            labelClass: 'font-italic',
            value: AdvertisedPriceCHeck,
            disclaimer: priceObject.AdvertisedPriceObj.Disclaimer,
          };

          const cashOffer = {
            label: '- Available Cash Offers  ',
            type: 'avalablecashprice',
            value: priceObject.isCashRebateObj.CashRebate,
            disclaimer: priceObject.isCashRebateObj.Disclaimer,
            labelClass: 'ml-4 ft-12',
            symbol: '-',
          };

          const discountedAdvertisedPrice = {
            label: 'Discounted Advertised Price',
            type: 'advertisedprice',
            value: AdvertisedPriceCHeck - priceObject.isCashRebateObj.CashRebate,
            disclaimer: '',
            labelClass: 'font-weight-bold  _theme_font_bold',
            valueClass: 'font-weight-bold  _theme_font_bold',
          };

          pricesList.push(MSRP);
          pricesList.push(dealerInstalledAccesories);
          dealerAdjustMentPrice?.value !== 0 && pricesList.push(dealerAdjustMentPrice);
          pricesList.push(AdvertisedPrice);
          pricesList.push(cashOffer);
          pricesList.push(discountedAdvertisedPrice);
        }
        // DIOs Present, Advertised Price = MSRP, Cash Rebate Present
        else if (
          priceObject.isDealerInstalledAccessoriesObj.DIOPrice &&
          priceObject.AdvertisedPriceObj.AdvertisedPrice === priceObject.MSRPObj.MSRP &&
          priceObject.isCashRebateObj.CashRebate
        ) {
          console.log('LOCKED : DIOs Present, Advertised Price = MSRP, Cash Rebate Present');

          const MSRP = {
            label: priceObject.MSRPObj.InMSRPLabel,
            type: 'msrp',
            value: priceObject.MSRPObj.MSRP,
            disclaimer: priceObject.MSRPObj.Disclaimer,
            labelClass: '',
            valueClass: '',
          };

          const dealerInstalledAccesories = {
            label: '+ Dealer Installed Accessories ',
            type: 'dealerinstalledaccess',
            value: priceObject.isDealerInstalledAccessoriesObj.DIOPrice,
            disclaimer: SMARTPATH_MESSAGES.DIA_Disclamer,
            labelClass: 'ml-4 ft-12',
          };

          const AdvertisedPriceCHeck = !priceObject.AdvertisedPriceObj.AdvertisedPrice
            ? priceObject.SmartPriceObj.SmartPrice
            : priceObject.AdvertisedPriceObj.AdvertisedPrice;

          const dealerAdjustMentPrice = {
            label: this.getDealerAdjustmentLabel(),
            type: 'dealerAdjustMentPrice',
            labelClass: 'ml-4 ft-12',
            value:
              AdvertisedPriceCHeck -
              (priceObject.MSRPObj.MSRP + priceObject.isDealerInstalledAccessoriesObj.DIOPrice),
            disclaimer: '',
            parentClass: 'sp-dealer-adjustment',
            priceValue: 'sp-dealer-adjustment-price',
          };

          const cashOffer = {
            label: '- Available Cash Offers  ',
            type: 'avalablecashprice',
            value: priceObject.isCashRebateObj.CashRebate,
            disclaimer: '',
            labelClass: 'ml-4 ft-12',
            symbol: '-',
          };

          const discountedAdvertisedPrice = {
            label: 'Discounted Advertised Price',
            type: 'advertisedprice',
            value: priceObject.AdvertisedPriceObj.AdvertisedPrice,
            disclaimer: '',
            labelClass: 'font-weight-bold  _theme_font_bold',
            valueClass: 'font-weight-bold  _theme_font_bold',
          };

          pricesList.push(MSRP);
          pricesList.push(dealerInstalledAccesories);
          dealerAdjustMentPrice?.value !== 0 && pricesList.push(dealerAdjustMentPrice);
          pricesList.push(cashOffer);
          pricesList.push(discountedAdvertisedPrice);
        }
        // 	DIOs Present, Advertised Price = MSRP+DIO*, Cash Rebate Absent
        else if (
          priceObject.isDealerInstalledAccessoriesObj.DIOPrice &&
          priceObject.AdvertisedPriceObj.AdvertisedPrice ===
            priceObject.MSRPObj.MSRP + priceObject.isDealerInstalledAccessoriesObj.DIOPrice &&
          !priceObject.isCashRebateObj.CashRebate
        ) {
          console.log('LOCKED : DIOs Present, Advertised Price = MSRP+DIO*, Cash Rebate Absent');

          const MSRP = {
            label: priceObject.MSRPObj.InMSRPLabel,
            type: 'msrp',
            value: priceObject.MSRPObj.MSRP,
            disclaimer: priceObject.MSRPObj.Disclaimer,
            labelClass: '',
            valueClass: '',
          };

          const dealerInstalledAccesories = {
            label: '+ Dealer Installed Accessories ',
            type: 'dealerinstalledaccess',
            value: priceObject.isDealerInstalledAccessoriesObj.DIOPrice,
            disclaimer: SMARTPATH_MESSAGES.DIA_Disclamer,
            labelClass: 'ml-4 ft-12',
          };

          const advertisedPrice = {
            label: 'Advertised Price',
            type: 'advertisedprice',
            value:
              priceObject.isCashRebateObj.AdvertisedPrice +
              priceObject.isDealerInstalledAccessoriesObj.DIOPrice,
            disclaimer: '',
            labelClass: 'font-weight-bold  _theme_font_bold',
            valueClass: 'font-weight-bold  _theme_font_bold',
          };

          pricesList.push(MSRP);
          pricesList.push(dealerInstalledAccesories);
          pricesList.push(advertisedPrice);
        }
        // 	DIOs Present, Advertised Price = MSRP+DIO*, Cash Rebate Present
        else if (
          priceObject.isDealerInstalledAccessoriesObj.DIOPrice &&
          priceObject.AdvertisedPriceObj.AdvertisedPrice ===
            priceObject.MSRPObj.MSRP + priceObject.isDealerInstalledAccessoriesObj.DIOPrice &&
          priceObject.isCashRebateObj.CashRebate
        ) {
          console.log('LOCKED : DIOs Present, Advertised Price = MSRP+DIO*, Cash Rebate Present');

          const MSRP = {
            label: priceObject.MSRPObj.InMSRPLabel,
            type: 'msrp',
            value: priceObject.MSRPObj.MSRP,
            disclaimer: priceObject.MSRPObj.Disclaimer,
            labelClass: '',
            valueClass: '',
          };

          const dealerInstalledAccesories = {
            label: '+ Dealer Installed Accessories ',
            type: 'dealerinstalledaccess',
            value: priceObject.isDealerInstalledAccessoriesObj.DIOPrice,
            disclaimer: SMARTPATH_MESSAGES.DIA_Disclamer,
            labelClass: 'ml-4 ft-12',
          };

          const advertisedPrice = {
            label: 'Advertised Price',
            type: 'advertisedprice',
            value:
              priceObject.isCashRebateObj.AdvertisedPrice +
              priceObject.isDealerInstalledAccessoriesObj.DIOPrice,
            disclaimer: '',
            labelClass: 'font-weight-bold  _theme_font_bold',
            valueClass: 'font-weight-bold  _theme_font_bold',
          };

          const cashOffer = {
            label: '- Available Cash Offers  ',
            type: 'avalablecashprice',
            value: priceObject.isCashRebateObj.CashRebate,
            disclaimer: priceObject.isCashRebateObj.Disclaimer,
            labelClass: 'ml-4 ft-12',
            symbol: '-',
          };

          const discountedAdvertisedPrice = {
            label: 'Discounted Advertised Price',
            type: 'DISCOUNTEDadvertisedprice',
            value: priceObject.AdvertisedPriceObj.AdvertisedPrice,
            disclaimer: '',
            labelClass: 'font-weight-bold  _theme_font_bold',
            valueClass: 'font-weight-bold  _theme_font_bold',
          };

          pricesList.push(MSRP);
          pricesList.push(dealerInstalledAccesories);
          pricesList.push(advertisedPrice);
          pricesList.push(cashOffer);
          pricesList.push(discountedAdvertisedPrice);
        } else {
          // No action needed for other cases.
        }
      } else if (
        // DIOs Absent, Advertised Price ≠ MSRP, Cash Rebate Absent, Price Unlocked
        !priceObject.isDealerInstalledAccessoriesObj.DIOPrice &&
        priceObject.AdvertisedPriceObj.AdvertisedPrice !== priceObject.MSRPObj.MSRP &&
        !priceObject.isCashRebateObj.CashRebate
      ) {
        console.log(
          'NOT LOCKED : DIOs Absent, Advertised Price ≠ MSRP, Cash Rebate Absent, Price Unlocked'
        );

        const MSRP = {
          label: priceObject.MSRPObj.InMSRPLabel,
          type: 'msrp',
          value: priceObject.MSRPObj.MSRP,
          disclaimer: priceObject.MSRPObj.Disclaimer,
          labelClass: '',
          valueClass: '',
        };

        const AdvertisedPriceCHeck = !priceObject.AdvertisedPriceObj.AdvertisedPrice
          ? priceObject.SmartPriceObj.SmartPrice
          : priceObject.AdvertisedPriceObj.AdvertisedPrice;

        const dealerAdjustMentPrice = {
          label: this.getDealerAdjustmentLabel(),
          type: 'dealeradvertisedprice',
          labelClass: 'ml-4 ft-12',
          value: AdvertisedPriceCHeck - priceObject.MSRPObj.MSRP,
          disclaimer: '',
          parentClass: 'sp-dealer-adjustment',
          priceValue: 'sp-dealer-adjustment-price',
        };

        const advertisedPrice = {
          label: 'Advertised Price ',
          type: 'advertisedprice',
          value: AdvertisedPriceCHeck,
          disclaimer: priceObject.AdvertisedPriceObj.Disclaimer,
          labelClass: 'font-italic',
        };

        const dealerPriceadjustmentPrice = {
          label: '+/- Dealer Price Adjustment',
          type: 'dealerPriceadjustmentPrice',
          value: priceObject.SmartPriceObj.SmartPrice - AdvertisedPriceCHeck,
          disclaimer: '',
          labelClass: 'ml-4 ft-12',
        };

        const smartPrice = {
          label: 'Smart Price',
          type: 'smartPrice',
          value: priceObject.SmartPriceObj.SmartPrice,
          labelClass: 'font-weight-bold  _theme_font_bold',
          valueClass: 'font-weight-bold  _theme_font_bold',
          disclaimer: priceObject.SmartPriceObj.Disclaimer,
        };

        pricesList.push(MSRP);
        dealerAdjustMentPrice?.value !== 0 && pricesList.push(dealerAdjustMentPrice);
        pricesList.push(advertisedPrice);
        if (dealerPriceadjustmentPrice.value) {
          pricesList.push(dealerPriceadjustmentPrice);
        }
        if (smartPrice.value !== advertisedPrice.value) {
          pricesList.push(smartPrice);
        }
      }
      // DIOs Absent, Advertised Price = MSRP, Cash Rebate Absent
      else if (
        !priceObject.isDealerInstalledAccessoriesObj.DIOPrice &&
        priceObject.AdvertisedPriceObj.AdvertisedPrice === priceObject.MSRPObj.MSRP &&
        !priceObject.isCashRebateObj.CashRebate
      ) {
        console.log('NOT LOCKED : DIOs Absent, Advertised Price = MSRP, Cash Rebate Absent');

        const MSRP = {
          label: priceObject.MSRPObj.InMSRPLabel,
          type: 'msrp',
          value: priceObject.MSRPObj.MSRP,
          disclaimer: priceObject.MSRPObj.Disclaimer,
          labelClass: '',
          valueClass: '',
        };
        const dealerPriceadjustmentPrice = {
          label: '+/- Dealer Price Adjustment',
          type: 'dealerPriceadjustmentPrice',
          value:
            priceObject.SmartPriceObj.SmartPrice - priceObject.AdvertisedPriceObj.AdvertisedPrice,
          disclaimer: '',
          labelClass: 'ml-4 ft-12',
        };

        const smartPrice = {
          label: 'Smart Price',
          type: 'smartPrice',
          value: priceObject.SmartPriceObj.SmartPrice,
          disclaimer: priceObject.SmartPriceObj.Disclaimer,
          labelClass: 'font-weight-bold  _theme_font_bold',
          valueClass: 'font-weight-bold  _theme_font_bold',
        };

        pricesList.push(MSRP);
        if (dealerPriceadjustmentPrice.value) {
          pricesList.push(dealerPriceadjustmentPrice);
        }
        pricesList.push(smartPrice);
      }
      // DIOs Absent, Advertised Price ≠ MSRP, Cash Rebate Present
      else if (
        !priceObject.isDealerInstalledAccessoriesObj.DIOPrice &&
        priceObject.AdvertisedPriceObj.AdvertisedPrice !== priceObject.MSRPObj.MSRP &&
        priceObject.isCashRebateObj.CashRebate
      ) {
        console.log('NOT LOCKED :  DIOs Absent, Advertised Price ≠ MSRP, Cash Rebate Present');

        const MSRP = {
          label: priceObject.MSRPObj.InMSRPLabel,
          type: 'msrp',
          value: priceObject.MSRPObj.MSRP,
          disclaimer: priceObject.MSRPObj.Disclaimer,
          labelClass: '',
          valueClass: '',
        };

        const AdvertisedPriceCHeck = !priceObject.AdvertisedPriceObj.AdvertisedPrice
          ? priceObject.SmartPriceObj.SmartPrice
          : priceObject.AdvertisedPriceObj.AdvertisedPrice;

        const dealerAdjustMentPrice = {
          label: this.getDealerAdjustmentLabel(),
          type: 'dealeradvertisedprice',
          labelClass: 'ml-4 ft-12',
          value: AdvertisedPriceCHeck - priceObject.MSRPObj.MSRP,
          disclaimer: '',
          parentClass: 'sp-dealer-adjustment',
          priceValue: 'sp-dealer-adjustment-price',
        };

        const adjustMentPrice = {
          label: 'Advertised Price ',
          type: 'advertisedprice',
          labelClass: 'font-italic',
          value: AdvertisedPriceCHeck,
          disclaimer: priceObject.AdvertisedPriceObj.Disclaimer,
        };

        const dealerPriceadjustmentPrice = {
          label: '+/- Dealer Price Adjustment',
          type: 'dealerPriceadjustmentPrice',
          value: priceObject.SmartPriceObj.SmartPrice - AdvertisedPriceCHeck,
          disclaimer: '',
          labelClass: 'ml-4 ft-12',
        };

        const smartPrice = {
          label: 'Smart Price',
          type: 'smartPrice',
          value: priceObject.SmartPriceObj.SmartPrice,
          disclaimer: priceObject.SmartPriceObj.Disclaimer,
          labelClass: 'font-weight-bold  _theme_font_bold',
          valueClass: 'font-weight-bold  _theme_font_bold',
        };

        const cashOffer = {
          label: '- Available Cash Offers  ',
          type: 'advertisedprice',
          value: priceObject.isCashRebateObj.CashRebate,
          disclaimer: priceObject.isCashRebateObj.Disclaimer,
          labelClass: 'ml-4 ft-12',
          symbol: '-',
        };

        const discountedSmartPrice = {
          label: 'Discounted Smart Price',
          type: 'advertisedprice',
          value: priceObject.SmartPriceObj.SmartPrice - priceObject.isCashRebateObj.CashRebate,
          disclaimer: '',
          labelClass: 'font-weight-bold  _theme_font_bold',
        };

        pricesList.push(MSRP);
        dealerAdjustMentPrice?.value !== 0 && pricesList.push(dealerAdjustMentPrice);
        pricesList.push(adjustMentPrice);
        if (dealerPriceadjustmentPrice.value) {
          pricesList.push(dealerPriceadjustmentPrice);
        }
        if (smartPrice.value !== adjustMentPrice.value) {
          pricesList.push(smartPrice);
        }
        pricesList.push(cashOffer);
        pricesList.push(discountedSmartPrice);
      }
      // DIOs Absent, Advertised Price = MSRP, Cash Rebate Present
      else if (
        !priceObject.isDealerInstalledAccessoriesObj.DIOPrice &&
        priceObject.AdvertisedPriceObj.AdvertisedPrice === priceObject.MSRPObj.MSRP &&
        priceObject.isCashRebateObj.CashRebate
      ) {
        console.log('NOT LOCKED :  DIOs Absent, Advertised Price = MSRP, Cash Rebate Present');

        const MSRP = {
          label: priceObject.MSRPObj.InMSRPLabel,
          type: 'msrp',
          value: priceObject.MSRPObj.MSRP,
          disclaimer: priceObject.MSRPObj.Disclaimer,
          labelClass: '',
          valueClass: '',
        };

        const dealerPriceadjustmentPrice = {
          label: '+/- Dealer Price Adjustment',
          type: 'dealerPriceadjustmentPrice',
          value:
            priceObject.SmartPriceObj.SmartPrice - priceObject.AdvertisedPriceObj.AdvertisedPrice,
          disclaimer: '',
          labelClass: 'ml-4 ft-12',
        };

        const smartPrice = {
          label: 'Smart Price',
          type: 'smartPrice',
          value: priceObject.SmartPriceObj.SmartPrice,
          disclaimer: priceObject.SmartPriceObj.Disclaimer,
          labelClass: 'font-weight-bold  _theme_font_bold',
          valueClass: 'font-weight-bold  _theme_font_bold',
        };

        const cashOffer = {
          label: '- Available Cash Offers',
          type: 'avalablecashprice',
          value: priceObject.isCashRebateObj.CashRebate,
          disclaimer: priceObject.isCashRebateObj.Disclaimer,
          labelClass: 'ml-4 ft-12',
          symbol: '-',
        };

        const discountedSmartPrice = {
          label: 'Discounted Smart Price',
          type: 'advertisedprice',
          value: priceObject.SmartPriceObj.SmartPrice - priceObject.isCashRebateObj.CashRebate,
          disclaimer: '',
          labelClass: 'font-weight-bold  _theme_font_bold',
        };

        pricesList.push(MSRP);
        if (dealerPriceadjustmentPrice.value) {
          pricesList.push(dealerPriceadjustmentPrice);
        }
        pricesList.push(smartPrice);
        pricesList.push(cashOffer);
        pricesList.push(discountedSmartPrice);
      }
      // DIOs Present, Advertised Price ≠ MSRP, Cash Rebate Absent
      else if (
        priceObject.isDealerInstalledAccessoriesObj.DIOPrice &&
        priceObject.AdvertisedPriceObj.AdvertisedPrice !== priceObject.MSRPObj.MSRP &&
        !priceObject.isCashRebateObj.CashRebate
      ) {
        console.log('NOT LOCKED : DIOs Present, Advertised Price ≠ MSRP, Cash Rebate Absent');

        const MSRP = {
          label: priceObject.MSRPObj.InMSRPLabel,
          type: 'msrp',
          value: priceObject.MSRPObj.MSRP,
          disclaimer: priceObject.MSRPObj.Disclaimer,
          labelClass: '',
          valueClass: '',
        };

        const dealerInstalledAccesories = {
          label: '+ Dealer Installed Accessories ',
          type: 'dealerinstalledaccess',
          value: priceObject.isDealerInstalledAccessoriesObj.DIOPrice,
          disclaimer: SMARTPATH_MESSAGES.DIA_Disclamer,
          labelClass: 'ml-4 ft-12',
        };

        const AdvertisedPriceCHeck = !priceObject.AdvertisedPriceObj.AdvertisedPrice
          ? priceObject.SmartPriceObj.SmartPrice
          : priceObject.AdvertisedPriceObj.AdvertisedPrice;

        const dealerAdjustMentPrice = {
          label: this.getDealerAdjustmentLabel(),
          type: 'dealeradvertisedprice',
          value:
            AdvertisedPriceCHeck -
            (priceObject.MSRPObj.MSRP + priceObject.isDealerInstalledAccessoriesObj.DIOPrice),
          disclaimer: '',
          labelClass: 'ml-4 ft-12',
          parentClass: 'sp-dealer-adjustment',
          priceValue: 'sp-dealer-adjustment-price',
        };

        const adjustMentPrice = {
          label: 'Advertised Price ',
          type: 'advertisedprice',
          labelClass: 'font-italic',
          value: AdvertisedPriceCHeck,
          disclaimer: priceObject.AdvertisedPriceObj.Disclaimer,
        };

        const dealerPriceadjustmentPrice = {
          label: '+/- Dealer Price Adjustment',
          type: 'dealerPriceadjustmentPrice',
          value: priceObject.SmartPriceObj.SmartPrice - AdvertisedPriceCHeck,
          disclaimer: '',
          labelClass: 'ml-4 ft-12',
        };

        const smartPrice = {
          label: 'Smart Price',
          type: 'smartPrice',
          value: priceObject.SmartPriceObj.SmartPrice,
          disclaimer: priceObject.SmartPriceObj.Disclaimer,
          labelClass: 'font-weight-bold  _theme_font_bold',
          valueClass: 'font-weight-bold  _theme_font_bold',
        };

        pricesList.push(MSRP);
        pricesList.push(dealerInstalledAccesories);
        dealerAdjustMentPrice?.value !== 0 && pricesList.push(dealerAdjustMentPrice);
        pricesList.push(adjustMentPrice);
        if (dealerPriceadjustmentPrice.value) {
          pricesList.push(dealerPriceadjustmentPrice);
        }
        if (smartPrice.value !== adjustMentPrice.value) {
          pricesList.push(smartPrice);
        }
      }
      // DIOs Present, Advertised Price = MSRP, Cash Rebate Absent
      else if (
        priceObject.isDealerInstalledAccessoriesObj.DIOPrice &&
        priceObject.AdvertisedPriceObj.AdvertisedPrice === priceObject.MSRPObj.MSRP &&
        !priceObject.isCashRebateObj.CashRebate
      ) {
        console.log('NOT LOCKED : DIOs Present, Advertised Price = MSRP, Cash Rebate Absent');

        const MSRP = {
          label: priceObject.MSRPObj.InMSRPLabel,
          type: 'msrp',
          value: priceObject.MSRPObj.MSRP,
          disclaimer: priceObject.MSRPObj.Disclaimer,
          labelClass: '',
          valueClass: '',
        };

        const dealerInstalledAccesories = {
          label: '+ Dealer Installed Accessories ',
          type: 'dealerinstalledaccess',
          value: priceObject.isDealerInstalledAccessoriesObj.DIOPrice,
          disclaimer: SMARTPATH_MESSAGES.DIA_Disclamer,
          labelClass: 'ml-4 ft-12',
        };

        const dealerPriceadjustmentPrice = {
          label: '+/-  Dealer Price Adjustment',
          type: 'dealerPriceadjustmentPrice',
          value:
            priceObject.SmartPriceObj.SmartPrice -
            (priceObject.AdvertisedPriceObj.AdvertisedPrice +
              priceObject.isDealerInstalledAccessoriesObj.DIOPrice),
          disclaimer: '',
          labelClass: 'ml-4 ft-12',
        };

        const smartPrice = {
          label: 'Smart Price',
          type: 'smartPrice',
          value: priceObject.SmartPriceObj.SmartPrice,
          disclaimer: priceObject.SmartPriceObj.Disclaimer,
          labelClass: 'font-weight-bold  _theme_font_bold',
          valueClass: 'font-weight-bold  _theme_font_bold',
        };

        pricesList.push(MSRP);
        pricesList.push(dealerInstalledAccesories);
        pricesList.push(dealerPriceadjustmentPrice);
        pricesList.push(smartPrice);
      }
      // DIOs Present, Advertised Price ≠ MSRP, Cash Rebate Present
      else if (
        priceObject.isDealerInstalledAccessoriesObj.DIOPrice &&
        priceObject.AdvertisedPriceObj.AdvertisedPrice !== priceObject.MSRPObj.MSRP &&
        priceObject.isCashRebateObj.CashRebate
      ) {
        console.log('NOT LOCKED : DIOs Present, Advertised Price ≠ MSRP, Cash Rebate Present');

        const MSRP = {
          label: priceObject.MSRPObj.InMSRPLabel,
          type: 'msrp',
          value: priceObject.MSRPObj.MSRP,
          disclaimer: priceObject.MSRPObj.Disclaimer,
          labelClass: '',
          valueClass: '',
        };

        const dealerInstalledAccesories = {
          label: '+ Dealer Installed Accessories ',
          type: 'dealerinstalledaccess',
          value: priceObject.isDealerInstalledAccessoriesObj.DIOPrice,
          disclaimer: SMARTPATH_MESSAGES.DIA_Disclamer,
          labelClass: 'ml-4 ft-12',
        };

        const AdvertisedPriceCHeck = !priceObject.AdvertisedPriceObj.AdvertisedPrice
          ? priceObject.SmartPriceObj.SmartPrice
          : priceObject.AdvertisedPriceObj.AdvertisedPrice;

        const dealerAdjustMentPrice = {
          label: this.getDealerAdjustmentLabel(),
          type: 'dealeradvertisedprice',
          labelClass: 'ml-4 ft-12',
          value:
            AdvertisedPriceCHeck -
            (priceObject.MSRPObj.MSRP + priceObject.isDealerInstalledAccessoriesObj.DIOPrice),
          disclaimer: '',
          parentClass: 'sp-dealer-adjustment',
          priceValue: 'sp-dealer-adjustment-price',
        };

        const advertisedPrice = {
          label: 'Advertised Price ',
          type: 'advertisedprice',
          labelClass: 'font-italic',
          value: AdvertisedPriceCHeck,
          disclaimer: priceObject.AdvertisedPriceObj.Disclaimer,
        };

        const dealerPriceadjustmentPrice = {
          label: '+/- Dealer Price Adjustment',
          type: 'dealerPriceadjustmentPrice',
          value: priceObject.SmartPriceObj.SmartPrice - AdvertisedPriceCHeck,
          disclaimer: '',
          labelClass: 'ml-4 ft-12',
        };

        const smartPrice = {
          label: 'Smart Price',
          type: 'smartPrice',
          value: priceObject.SmartPriceObj.SmartPrice,
          disclaimer: priceObject.SmartPriceObj.Disclaimer,
          labelClass: 'font-weight-bold  _theme_font_bold',
          valueClass: 'font-weight-bold  _theme_font_bold',
        };

        const cashOffer = {
          label: '- Available Cash Offers',
          type: 'avalablecashprice',
          value: priceObject.isCashRebateObj.CashRebate,
          disclaimer: priceObject.isCashRebateObj.Disclaimer,
          labelClass: 'ml-4 ft-12',
          symbol: '-',
        };

        const discountedSmartPrice = {
          label: 'Discounted Smart Price',
          type: 'advertisedprice',
          value: priceObject.SmartPriceObj.SmartPrice - priceObject.isCashRebateObj.CashRebate,
          disclaimer: '',
          labelClass: 'font-weight-bold  _theme_font_bold',
        };

        pricesList.push(MSRP);
        pricesList.push(dealerInstalledAccesories);
        dealerAdjustMentPrice?.value !== 0 && pricesList.push(dealerAdjustMentPrice);
        pricesList.push(advertisedPrice);
        if (dealerPriceadjustmentPrice.value) {
          pricesList.push(dealerPriceadjustmentPrice);
        }
        if (smartPrice.value !== advertisedPrice.value) {
          pricesList.push(smartPrice);
        }
        pricesList.push(cashOffer);
        pricesList.push(discountedSmartPrice);
      }
      // DIOs Present, Advertised Price = MSRP, Cash Rebate Present
      else if (
        priceObject.isDealerInstalledAccessoriesObj.DIOPrice &&
        priceObject.AdvertisedPriceObj.AdvertisedPrice === priceObject.MSRPObj.MSRP &&
        priceObject.isCashRebateObj.CashRebate
      ) {
        console.log('NOT LOCKED : DIOs Present, Advertised Price = MSRP, Cash Rebate Present');

        const MSRP = {
          label: priceObject.MSRPObj.InMSRPLabel,
          type: 'msrp',
          value: priceObject.MSRPObj.MSRP,
          disclaimer: priceObject.MSRPObj.Disclaimer,
          labelClass: '',
          valueClass: '',
        };

        const dealerInstalledAccesories = {
          label: '+ Dealer Installed Accessories ',
          type: 'dealerinstalledaccess',
          value: priceObject.isDealerInstalledAccessoriesObj.DIOPrice,
          disclaimer: SMARTPATH_MESSAGES.DIA_Disclamer,
          labelClass: 'ml-4 ft-12',
        };

        const dealerPriceadjustmentPrice = {
          label: '+/- Dealer Price Adjustment',
          type: 'dealerPriceadjustmentPrice',
          value:
            priceObject.SmartPriceObj.SmartPrice -
            (priceObject.AdvertisedPriceObj.AdvertisedPrice +
              priceObject.isDealerInstalledAccessoriesObj.DIOPrice),
          disclaimer: '',
          labelClass: 'ml-4 ft-12',
        };

        const smartPrice = {
          label: 'Smart Price',
          type: 'smartPrice',
          value: priceObject.SmartPriceObj.SmartPrice,
          disclaimer: '',
          labelClass: 'font-weight-bold  _theme_font_bold',
          valueClass: 'font-weight-bold  _theme_font_bold',
        };

        const cashOffer = {
          label: '- Available Cash Offers',
          type: 'avalablecashprice',
          value: priceObject.isCashRebateObj.CashRebate,
          disclaimer: priceObject.isCashRebateObj.Disclaimer,
          labelClass: 'ml-4 ft-12',
          symbol: '-',
        };

        const discountedSmartPrice = {
          label: 'Discounted Smart Price',
          type: 'advertisedprice',
          value: priceObject.SmartPriceObj.SmartPrice - priceObject.isCashRebateObj.CashRebate,
          disclaimer: '',
          labelClass: 'font-weight-bold  _theme_font_bold',
          valueClass: 'font-weight-bold  _theme_font_bold',
        };

        pricesList.push(MSRP);
        pricesList.push(dealerInstalledAccesories);
        if (dealerPriceadjustmentPrice.value) {
          pricesList.push(dealerPriceadjustmentPrice);
        }
        pricesList.push(smartPrice);
        pricesList.push(cashOffer);
        pricesList.push(discountedSmartPrice);
      }
      // DIOs Present, Advertised Price = MSRP+DIO, Cash Rebate Absent
      else if (
        priceObject.isDealerInstalledAccessoriesObj.DIOPrice &&
        priceObject.AdvertisedPriceObj.AdvertisedPrice ===
          priceObject.MSRPObj.MSRP + priceObject.isDealerInstalledAccessoriesObj.DIOPrice &&
        !priceObject.isCashRebateObj.CashRebate
      ) {
        console.log('NOT LOCKED : DIOs Present, Advertised Price = MSRP+DIO, Cash Rebate Absent');

        const MSRP = {
          label: priceObject.MSRPObj.InMSRPLabel,
          type: 'msrp',
          value: priceObject.MSRPObj.MSRP,
          disclaimer: priceObject.MSRPObj.Disclaimer,
          labelClass: '',
          valueClass: '',
        };

        const dealerInstalledAccesories = {
          label: '+ Dealer Installed Accessories ',
          type: 'dealerinstalledaccess',
          value: priceObject.isDealerInstalledAccessoriesObj.DIOPrice,
          disclaimer: SMARTPATH_MESSAGES.DIA_Disclamer,
          labelClass: 'ml-4 ft-12',
        };

        const advertisedPrice = {
          label: 'Advertised Price ',
          type: 'advertisedprice',
          labelClass: '',
          value: priceObject.MSRPObj.MSRP + priceObject.isDealerInstalledAccessoriesObj.DIOPrice,
          disclaimer: priceObject.AdvertisedPriceObj.Disclaimer,
        };

        const dealerPriceadjustmentPrice = {
          label: '+/- Dealer Price Adjustment',
          type: 'dealerPriceadjustmentPrice',
          value:
            priceObject.SmartPriceObj.SmartPrice - priceObject.AdvertisedPriceObj.AdvertisedPrice,
          disclaimer: '',
          labelClass: 'ml-4 ft-12',
        };

        const smartPrice = {
          label: 'Smart Price',
          type: 'smartPrice',
          value: priceObject.SmartPriceObj.SmartPrice,
          disclaimer: priceObject.SmartPriceObj.Disclaimer,
          labelClass: 'font-weight-bold  _theme_font_bold',
          valueClass: 'font-weight-bold  _theme_font_bold',
        };

        pricesList.push(MSRP);
        pricesList.push(dealerInstalledAccesories);
        pricesList.push(advertisedPrice);
        if (dealerPriceadjustmentPrice.value) {
          pricesList.push(dealerPriceadjustmentPrice);
        }
        if (smartPrice.value !== advertisedPrice.value) {
          pricesList.push(smartPrice);
        }
      }
      // DIOs Present, Advertised Price = MSRP+DIO, Cash Rebate Present
      else if (
        priceObject.isDealerInstalledAccessoriesObj.DIOPrice &&
        priceObject.AdvertisedPriceObj.AdvertisedPrice ===
          priceObject.MSRPObj.MSRP + priceObject.isDealerInstalledAccessoriesObj.DIOPrice &&
        priceObject.isCashRebateObj.CashRebate
      ) {
        console.log('NOT LOCKED : DIOs Present, Advertised Price = MSRP+DIO, Cash Rebate Present');

        const MSRP = {
          label: priceObject.MSRPObj.InMSRPLabel,
          type: 'msrp',
          value: priceObject.MSRPObj.MSRP,
          disclaimer: priceObject.MSRPObj.Disclaimer,
          labelClass: '',
          valueClass: '',
        };

        const dealerInstalledAccesories = {
          label: '+ Dealer Installed Accessories ',
          type: 'dealerinstalledaccess',
          value: priceObject.isDealerInstalledAccessoriesObj.DIOPrice,
          disclaimer: SMARTPATH_MESSAGES.DIA_Disclamer,
          labelClass: 'ml-4 ft-12',
        };

        const advertisedPrice = {
          label: 'Advertised Price ',
          type: 'advertisedprice',
          labelClass: '',
          value: priceObject.MSRPObj.MSRP + priceObject.isDealerInstalledAccessoriesObj.DIOPrice,
          disclaimer: priceObject.AdvertisedPriceObj.Disclaimer,
        };

        const dealerPriceadjustmentPrice = {
          label: '+/- Dealer Price Adjustment',
          type: 'dealerPriceadjustmentPrice',
          value:
            priceObject.SmartPriceObj.SmartPrice - priceObject.AdvertisedPriceObj.AdvertisedPrice,
          disclaimer: '',
          labelClass: 'ml-4 ft-12',
        };

        const smartPrice = {
          label: 'Smart Price',
          type: 'smartPrice',
          value: priceObject.SmartPriceObj.SmartPrice,
          disclaimer: priceObject.SmartPriceObj.Disclaimer,
          labelClass: 'font-weight-bold  _theme_font_bold',
          valueClass: 'font-weight-bold  _theme_font_bold',
        };

        const cashOffer = {
          label: '- Available Cash Offers',
          type: 'avalablecashprice',
          value: priceObject.isCashRebateObj.CashRebate,
          disclaimer: priceObject.isCashRebateObj.Disclaimer,
          labelClass: 'ml-4 ft-12',
          symbol: '-',
        };

        const discountedSmartPrice = {
          label: 'Discounted Smart Price',
          type: 'advertisedprice',
          value: priceObject.SmartPriceObj.SmartPrice - priceObject.isCashRebateObj.CashRebate,
          disclaimer: '',
          labelClass: 'font-weight-bold  _theme_font_bold',
        };

        pricesList.push(MSRP);
        pricesList.push(dealerInstalledAccesories);
        pricesList.push(advertisedPrice);
        if (dealerPriceadjustmentPrice.value) {
          pricesList.push(dealerPriceadjustmentPrice);
        }
        if (smartPrice.value !== advertisedPrice.value) {
          pricesList.push(smartPrice);
        }
        pricesList.push(cashOffer);
        pricesList.push(discountedSmartPrice);
      } else {
        // No action needed for other cases.
      }
    }
    return pricesList;
  }

  static isSmartPathCTAsAllowed(ctaType) {
    return true;
  }

  static smartPathRedirectionCondition(type, option) {
    return window.isSmartPathEnabled && SMARTPATH_CTAs.includes(option?.toLowerCase());
  }

  static async getToyotaDealerServiceDisclaimer() {
    try {
      return await Axios.get(
        `${window.ApiBaseUrl}/OEMProgramsCommon/DealerInventoryDisclaimersByOEMCode?oemCode=${window.oemCode}`
      );
    } catch (error) {
      console.log(error);
    }
  }

  static async getDDOADisclaimers(year, model) {
    try {
      if (model?.toLowerCase().includes('tundra i-force')) {
        model = 'tundrahybrid';
      }
      return await Axios.get(
        `${window.ApiBaseUrl}/OEMProgramsCommon/GetDDOADisclaimers?year=${year}&series=${model}`
      );
    } catch (error) {
      console.log(error);
    }
  }

  static smartpathDisclaimerPriceMapping(disclaimerString) {
    const map = new Map();
    if (disclaimerString) {
      for (const iterator of disclaimerString.split('|')) {
        let [disclaimerName, disclaimerType] = iterator.split('~');
        const disclaimerNameValue = disclaimerName?.replace('disclaimerName:', '').trim();
        const disclaimerTypeValue = disclaimerType?.replace('@disclaimerType:', '').trim();
        if (disclaimerTypeValue === 'Selling Price' || disclaimerTypeValue === 'Advertise Price') {
          let key = disclaimerTypeValue;
          if (key === 'Selling Price') key = 'Smart Price';
          if (key === 'Advertise Price') key = 'Advertised Price';
          map.set(key.toLowerCase().trim(), disclaimerNameValue);
        }
      }
    }
    return map;
  }

  static priceStackDisclaimerCloseEvent(root) {
    document.addEventListener('click', () => {
      root?.$root?.$emit?.('close-all-smartpath-disclaimer');
    });
  }
  static isSmartPathDgIdAvailable() {
    if (
      window.environment?.toLowerCase() === 'development' ||
      window.environment?.toLowerCase() === 'stage'
    ) {
      return window.isSmartPathEnabled && window.DGDataHub;
    }
    return window.isSmartPathEnabled && window.DGDataHub?.getDgid();
  }
}
